import {
  identityApi as api,
  identityApiV2,
  unAuthenticatedIdentityApi as baseApi,
} from "../Api";
import setupInterceptors from "../setupInterceptors";

const identitySetupInterceptors = () => {
  setupInterceptors(baseApi, true);
  setupInterceptors(identityApiV2);
  return setupInterceptors(api);
};

export default identitySetupInterceptors;
